import { useMediaQuery } from "@shared/First";
import "../style/Product.scss";

// entities/product/ui/ProductItem.jsx
const ProductItem = ({ product, onChatClick }) => {
  const isMobile = useMediaQuery("(max-width: 800px)");
  const properties = product?.crm?.properties || [];

  console.log("CHAT PROD", product)

  return (
    <div className="product-item">
      <div className="product-item__image">
        <img src={product?.crm?.thumbnail_url || product?.crm?.product?.thumbnail_url || "/img/product.png"} alt="product" />
        {isMobile && (
          <h4 className="product-item__title">
            {product?.crm?.product?.name || "Без названия"}
          </h4>
        )}
      </div>

      <div className="product-item__info">
        {!isMobile && (
          <h4 className="product-item__title">
            {product?.crm?.product?.name || "Без названия"}
          </h4>
        )}

        <div className="product-item__attributes">
          <div className="product-item__attribute">
            <span className="product-item__attribute-label">Арт:</span>
            <span className="product-item__attribute-value">
              {product?.crm?.sku}
            </span>
          </div>

          <div className="product-item__attribute">
            <span className="product-item__attribute-label">Цена:</span>
            <span className="product-item__attribute-value">
              {product?.crm?.price} грн
            </span>
          </div>

          {properties.map((prop, idx) => (
            <div className="product-item__attribute" key={idx}>
              <span className="product-item__attribute-label">{prop.name}:</span>
              <span className="product-item__attribute-value">{prop.value}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="product-item__actions">
        <button
          className="product-item__chat-btn"
          onClick={onChatClick}
        >
          Чат
        </button>
      </div>
    </div>
  );
};
export default ProductItem;